var map = {
	"./zayn-1.jpeg": 241,
	"./zayn-10.jpeg": 8970,
	"./zayn-2.jpeg": 4267,
	"./zayn-3.jpeg": 690,
	"./zayn-4.jpeg": 4827,
	"./zayn-5.jpeg": 5039,
	"./zayn-7.jpeg": 3953,
	"./zayn-8.jpeg": 533,
	"./zayn-9.jpeg": 4575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8997;